import { render, staticRenderFns } from "./CustomerPricingProductsTable.vue?vue&type=template&id=25625f44&"
import script from "./CustomerPricingProductsTable.vue?vue&type=script&lang=js&"
export * from "./CustomerPricingProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports